module.exports = __webpack_public_path__ + "static/img/chatroom_upload.db3c41c8.svg";